import React, { Component } from 'react';
import CreateCourseModals from '../../course/components/CreateCourseModals';
import courseService from "../services/courseService";
import { WithStyles } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Typography, Button } from '@material-ui/core';
import NoContent from './NoContent';
import WithContent from './WithContent';
import ContentTopMenu from '../components/ContentTopMenu';
import MoreVertModals from '../components/more_vertModal';
import CourseFilterDrawer from '../components/CourseFilterDrawer'
import _ from 'lodash';
import {styles} from '../styling/CreateCourse'
import CloseRounded from '@material-ui/icons/Cancel';
import cx from "classnames";
import {CourseBasicInfo} from '../modals/CourseBasicInfo';
import {KeyValue,OnlyKey,FilterData} from '../modals/CommonModels';
interface CreateCourseProps extends WithStyles<typeof styles> {
}

interface CreateCourseStates {
	hasContent: Boolean,
	createContentOpen: Boolean,
	addMilestoneOpen: Boolean,
	isFilterDrawerOpen: Boolean,
	goalsList: KeyValue[],
	filterData: FilterData,
	courseData: CourseBasicInfo[],
	gradeList:OnlyKey[],
	filterOption:string,
	sortOption:string,
}

class CreateCourse extends Component<CreateCourseProps, CreateCourseStates> {
	constructor(props: CreateCourseProps) {
		super(props);

		this.state = {
			hasContent: true,
			createContentOpen: false,
			addMilestoneOpen: false,
			isFilterDrawerOpen: false,
			goalsList: [],
			filterData: {},
			courseData: [],
			gradeList:[],
			filterOption:"Course Filter",
			sortOption:"",
		};

		this.createContentOpenHandler = this.createContentOpenHandler.bind(this);
		this.createContentCloseHandler = this.createContentCloseHandler.bind(this);
		this.openMilestoneHandler = this.openMilestoneHandler.bind(this);
		this.openMilestoneCloseHandler = this.openMilestoneCloseHandler.bind(this);
		this.handleFilterOpen = this.handleFilterOpen.bind(this);
		this.handleFilterClose = this.handleFilterClose.bind(this);
		this.changeFilterOptions = this.changeFilterOptions.bind(this);
		this.getCourseData = this.getCourseData.bind(this);
		this.renderFilterChips=this.renderFilterChips.bind(this);
	}

	componentDidMount() {
		var self = this;
		courseService.getAllCourses().then((goals: KeyValue[]) => {
			self.setState({ goalsList: goals });
		});
		
		courseService.getAllGrade().then((grade: OnlyKey[]) => {
			self.setState({ gradeList: grade });
		});
		
		this.getCourseData();
	}

	createContentOpenHandler = (event: any) => {
		event.preventDefault();
		var self = this;
		self.setState({
			createContentOpen: true
		});
	};

	createContentCloseHandler = (event: any) => {
		this.setState({
			createContentOpen: false
		});
	};

	openMilestoneHandler = (event: any) => {
		this.setState({
			addMilestoneOpen: true
		})
	}
	openMilestoneCloseHandler() {
		this.setState({
			addMilestoneOpen: false
		})
	}

	handleFilterOpen = (details: string) => {
		
		if(details == "Archived Course"){
			window.location.href = `${window.location.origin}/archive-course`
		}
		else{
			this.setState({
				isFilterDrawerOpen: true,
				filterOption:details
			});
		}
		
	};

	handleFilterClose = (event: any) => {
		this.setState({
			isFilterDrawerOpen: false,
		});
	};

	changeFilterOptions(type: string, value: string) {
		const { filterData } = this.state;	
		var self = this;

		switch (type) {
			case "status":
				var dataArr = filterData.status || []
				if(dataArr.indexOf(value) == -1){
					dataArr.push(value) 
				} else{
					dataArr = dataArr.filter(function(v:string){
						return v != value
					})
				}
				filterData.status = dataArr
				self.setState({
					filterData: filterData
				})
				break;
			case "goals":
				var dataArr = filterData.goals || []
	
				if(dataArr.indexOf(value) == -1){
					dataArr.push(value) 
				} else{
					dataArr = dataArr.filter(function(v:string){
						return v != value
					})
				}
				filterData.goals = dataArr
				self.setState({
					filterData: filterData
				})
				break;

			case "grade":
				var dataArr = filterData.grade || []
				if(dataArr.indexOf(value) == -1){
					dataArr.push(value) 
				} else{
					dataArr = dataArr.filter(function(v:string){
						return v != value
					})
				}
				filterData.grade = dataArr
				self.setState({
					filterData: filterData
				})
				break;

			case "startDate":
					
					if(value == ""){
						delete filterData["startDate"];
					}else{
						filterData.startDate = value
					}
					self.setState({
						filterData: filterData
					})
				break;

			case "endDate":
					if(value == ""){
						delete filterData["endDate"];
					}else{
						filterData.endDate = value
					}
					
					self.setState({
						filterData: filterData
					})
				break;
			case "sortBy":
				filterData.sortBy = value
				self.setState({
					filterData: filterData
				})
			break;
		}

		setTimeout(function () {
			self.getCourseData()
		}, 0)
	}

	getCourseData() {
		const { filterData } = this.state;
		let filterString = "?Archive=false"
		let self = this
		//FilterStatus
		let filterStatus = (filterData.status || []).join(",");
		if (filterStatus !== "") {
			filterString = `${filterString}&status=${filterStatus}`
		}

		//FilterGoals
		let filterGoalsData = (filterData.goals || []).join(",");
		if (filterGoalsData !== "") {
			filterString = `${filterString}&goals=${filterGoalsData}`
		}

		//FilterGrade
		let filterGrade = (filterData.grade || []).join(",");
		if (filterGrade !== "") {
			filterString = `${filterString}&grade=${filterGrade}`
		}

		//FilterDate
		if ((filterData.startDate || "") !== "") {
			filterString = `${filterString}&startDate=${filterData.startDate}`
		}
		if ((filterData.endDate || "") !== "") {
			filterString = `${filterString}&endDate=${filterData.endDate}`
		}
		if ((filterData.sortBy || "") !== "") {
			filterString = `${filterString}&sort=${filterData.sortBy}`
		}

		courseService.getCourseData(filterString.substring(1,filterString.length)).then((courseData: CourseBasicInfo[]) => {
			if(courseData.length>0){
				self.setState({
					courseData: courseData,
					hasContent:true
				})
			}else{
				self.setState({
					courseData: courseData,
					hasContent:false
				})
			}	
		});
	}

	renderFilterChips(){
		const { classes } = this.props;
		const {filterData,goalsList,courseData} = this.state;
		let self = this;
		let getKeysArr = Object.keys(filterData)
		let _html : any = []
		getKeysArr.map(function(v:string){
				switch(v){
					case "status":
							(filterData["status"] || []).map(function(v:string){
								_html.push(<span className={classes.breadSyllabus}>
									{v} <CloseRounded onClick={()=>self.changeFilterOptions("status",v)}/>
								</span>)
							})
					break;

					case "grade":
							(filterData["grade"] || []).map(function(v:string){
								_html.push(<span className={classes.breadSyllabus}>
									{v} <CloseRounded onClick={()=>self.changeFilterOptions("grade",v)}/>
								</span>)
							})
					break;

					case "goals":
							
							(filterData["goals"] || []).map(function(v:string){
								var getGoalName:KeyValue[] = goalsList.filter(function(value:KeyValue){
									return value._id == v
								})
								_html.push(<span className={classes.breadSyllabus}>
									{getGoalName[0].name} <CloseRounded onClick={()=>self.changeFilterOptions("goals",v)}/>
								</span>)
							})
					break;

					case "startDate":
							_html.push(<span className={classes.breadSyllabus}>
								{filterData["startDate"]} <CloseRounded onClick={()=>self.changeFilterOptions("startDate","")}/>
							</span>)
					break;

					case "endDate":
							_html.push(<span className={classes.breadSyllabus}>
								{filterData["endDate"]} <CloseRounded onClick={()=>self.changeFilterOptions("endDate","")}/>
							</span>)
					break;
				}
		})
		
		if(_html.length>0){
			_html.push(<span className={classes.breadSyllabusResult}>
				{courseData.length} Results
			</span>)
		}
		return _html 
	}

	render() {
		const { classes } = this.props;
		const { hasContent, isFilterDrawerOpen, createContentOpen,courseData ,filterData} = this.state;
		const Content = hasContent ? <WithContent courseListingData = {courseData}/> : <NoContent createContentOpenHandler={this.createContentOpenHandler}/>;
		
		var self = this;
		return (
			<Grid container
				spacing={0}
				direction="column"
				className={classes.root}>
					
				<Grid item xs={12}>
					<Grid container>
						<Grid item xs={1}></Grid>
						<Grid item xs={7} className={classes.headerTitle}>
							<Typography style={{paddingLeft:"16px",position:'absolute'}}variant="h6">
								Courses
								{self.renderFilterChips()}
							</Typography>
						</Grid>
						<Grid item xs={4} style={{right:"110px",position:'relative'}}className={classes.headerActions}>
							
							<div className={classes.floatLeft}>
								<MoreVertModals  clicked={this.handleFilterOpen} />
							</div>
							
							<div className={classes.floatLeft}>
								<ContentTopMenu />
							</div>

							{hasContent && (
								<>
									<Button 
										className={cx(classes.createContentButton,classes.floatLeft)}
										variant="contained"
										color="primary"
										onClick={this.createContentOpenHandler.bind(this)}
									>
										Create Course
									</Button>
									
								</>
							)}
							
							
						
						</Grid>
						
					
					</Grid>
				</Grid>

				<Grid item xs={12}>
					{Content}
				</Grid>
				<CourseFilterDrawer
					onFilterDrawerClose={this.handleFilterClose}
					isFilterDrawerOpen={isFilterDrawerOpen}
					createContentGoals={self.state.goalsList}
					gradeList = {self.state.gradeList}
					onFilterChange={this.changeFilterOptions.bind(this)}
					filteredData={this.state.filterData}
					filterFlag = {this.state.filterOption}
				/>

<CreateCourseModals
										createContentOpen={createContentOpen}
										createContentCloseHandler={this.createContentCloseHandler.bind(this)}
										createContentGoals={self.state.goalsList}
									/>
			</Grid>
		)
	}
}

// @ts-ignore
export default withStyles(styles)(CreateCourse);